<template>
  <el-cascader
      style="width: 100%"
      class="deptCascadeEdit"
      ref="deptCascadeEdit"
      v-model="values"
      :options="options"
      :props="{ checkStrictly: true, emitPath: false, value: 'id', label: 'name' }"
      clearable
      filterable
      :disabled="disabled"
      :show-all-levels="false"
      size="mini"
      @change="handleChange">
  </el-cascader>
</template>
<script>

import { validatenull } from '@/tdcommon/validate'
import { fetchEnableTree } from '@/api/admin/dept'
import { deepClone } from '@/tdcommon/beeutil'

export default {
  // 部门级联选择 单选 数据只有启用的部门 支持搜索 仅显示选择的最后一级
  name: 'd2-container-dept-cascadeEdit',
  data () {
    return {
      values: null,
      options: [],
      loading: false
    }
  },
  props: {
    mdmStr: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {},
  methods: {
    async remoteMethod () {
      this.loading = true
      try {
        const response = await fetchEnableTree()
        if (response.code === 0) {
          this.options = validatenull(response.data) ? [] : this.filterEmptyChildren(response.data[0].children)
          console.log('this.options', this.options)
        }
      } catch (err) {

      } finally {
        this.loading = false
        this.getDefaultValues()
      }
    },
    // 过滤掉最后一级的空children
    filterEmptyChildren (data) {
      // 深拷贝数据，避免修改原始数据
      const cloneData = deepClone(data)

      // 递归处理每个节点
      function processNode (node) {
        // 如果节点有children且children数组为空，则删除children属性
        if (node.children && Array.isArray(node.children) && node.children.length === 0) {
          delete node.children
        }
        // 如果节点有children且children不为空，则递归处理每个子节点
        else if (node.children && Array.isArray(node.children) && node.children.length > 0) {
          node.children.forEach(child => processNode(child))
        }
      }

      // 处理根节点数组中的每个节点
      cloneData.forEach(node => processNode(node))

      return cloneData
    },
    handleChange (val) {
      console.log('handleChange', val)
      this.$emit('change', val)
    },
    getDefaultValues () {
      if (!validatenull(this.mdmStr)) {
        console.log('getDefaultValues-this.mdmStr', this.mdmStr)
        let deptId = this.$parent.elForm.model[this.mdmStr]
        console.log('getDefaultValues-deptId', deptId)
        console.log('typeof-deptId', typeof deptId)
        if (!validatenull(deptId)) {
          this.values = Number(deptId)
        } else {
          this.values = null
        }
      }
    }
  },
  watch: {
    values: function (val, oldVal) {
      if (val !== oldVal) {
        console.log('watch-values-val', val)
        // this.$emit('input', val)
      }
    }
  },
  mounted () {
    this.remoteMethod()
  }
}
</script>

<style lang="scss" scoped>
.deptCascadeEdit {
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-dept-cascadeEdit/index.vue"
}
</vue-filename-injector>
